import { useQuery } from '@apollo/client';
import { GET_TEAM_BY_ID } from '../../graphql/queries';

const useGetTeamById = (params = {}) => {
  const { data, loading } = useQuery(GET_TEAM_BY_ID, {
    variables: { id: params?.teamId },
    skip: !params?.teamId,
  });

  return {
    loading,
    data: data?.list,
  };
};

export default {
  useGetTeamById,
};
